import ActionType from 'actions/ActionType'
import { Auth } from 'utils/Auth'
import { reduce } from 'lodash'
import { create, update } from 'actions/data'
import API_URL from 'utils/ApiUrl'

export const createOrUpdateCampaign = () => (dispatch, getState) =>
	new Promise((resolve, reject) => {
		const addOrEdit = getState().campaign.addOrEdit
		const id = addOrEdit.campaign.id
		const { fields, stages, calendar } = addOrEdit.campaign

		const basicCampaignData = reduce(
			fields,
			(result, value, key) => {
				if (key === 'start_date' || key === 'end_date') {
					if (id === 'new') {
						if (
							value &&
							Object.prototype.toString.call(value) === '[object Date]'
						) {
							result[key] = value.toISOString()
						}
					} else {
						if (
							value &&
							Object.prototype.toString.call(value) === '[object Date]'
						) {
							result[key] = value.toISOString()
						} /*  else {
              result[key] = null
            } */
					}
				} else {
					if (value) result[key] = value
				}
				return result
			},
			{},
		)

		const filteredStages = stages.map((stage) => {
			if (stage?.tasks?.length) {
				return {
					...stage,
					tasks: stage.tasks?.filter(
						(task) => task?.slice(0, 12) !== 'placeholder_',
					),
				}
			}
			return stage
		})

		const campaign =
			id === 'new'
				? basicCampaignData
				: { ...basicCampaignData, id, stages: filteredStages, calendar }

		dispatch({
			type: 'create or update campaign attempt',
			campaign,
		})

		if (campaign.name) {
			if (id === 'new') {
				return resolve(
          dispatch(create({ entity: campaign, entityType: 'campaign' })),
        )
			} else {
				return resolve(dispatch(update(campaign, 'campaign')))
			}
		} else {
			resolve()
		}
	})

export const listContactsInStage =
	(campaignID, stageID) => (dispatch, getState) =>
		new Promise((resolve, reject) => {
			dispatch({ type: ActionType.Campaign.LIST_CONTACTS_IN_STAGE_REQUEST })

			const cursorValue = getState().cursor?.contactsInStage?.cursor

      return Auth.currentSession()
        .then(session => {
          const headerValue = `Bearer ${session.idToken.jwtToken}`

          return fetch(
            `${API_URL}/campaign/${campaignID}/stage/${stageID}/contact?pageSize=30${
              cursorValue ? `&cur=${cursorValue}` : ''
            }`,
            {
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              headers: {
                'content-type': 'application/json',
                authorization: headerValue,
              },
              method: 'GET', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, cors, *same-origin
              redirect: 'follow', // manual, *follow, error
              referrer: 'no-referrer', // *client, no-referrer
            },
          )
            .then(res => {
              const cursor = res?.headers?.get?.('x-vast-list-cursor')

              return res.json().then(data => {
                const newData = { response: data }

                if (cursor) {
                  newData.cursor = cursor
                }

                if (!res.ok) {
                  newData.notOk = true
                }

                return newData
              })
            })
            .then(payload => {
              if (payload && payload.notOk) {
                dispatch({
                  type: ActionType.Campaign.LIST_CONTACTS_IN_STAGE_FAILURE,
                  payload,
                  notOk: true,
                })
                reject(payload)
                return
              }

              dispatch({
                type: ActionType.Campaign.LIST_CONTACTS_IN_STAGE_SUCCESS,
                payload: payload.response,
                cursor: payload.cursor,
              })
              resolve(payload.response)
            })
            .catch(error => {
              dispatch({
                type: ActionType.Campaign.LIST_CONTACTS_IN_STAGE_FAILURE,
                payload: error,
              })
              reject(error)
            })
        })
        .catch(err => {
          console.log(err)
          if (err.code === 'UserNotFoundException') {
            window.localStorage.clear()
            window.location.reload(true)
          }
        })
		})
